// Copyright (c) 2020-2023 Visual Intelligence LP. All rights reserved.
//
import Form from '@core/forms/base';
import { COMMENT_FIELDS } from '@shared/constants/comment';

export default class CommentForm extends Form {
  setup() {
    return {
      fields: [
        {
          name: COMMENT_FIELDS.body,
          type: 'text',
          rules: 'required',
          options: {
            validateOnBlur: false,
            validateOnSubmit: true,
          },
        }
      ]
    };
  }
}